import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { throwError, NEVER, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { WINDOW } from '../../shared/providers/window';
import { ErrorService } from './error.service';

@Injectable()
export class HttpServiceInterceptor implements HttpInterceptor {
  // エラーページへリダイレクトさせなくてもよいURLをホワイトリストで定義
  readonly #whiteLists = ['/classi/api/settings/student_order', '/classi/api/menu'];
  readonly #errorService = inject(ErrorService);
  readonly #window = inject(WINDOW);

  readonly #DEFAULT_ERROR_MESSAGE =
    'システムエラーが発生しました。お手数ですが、繰り返し発生する場合はClassiサポートデスクへお問い合わせください。';

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const handler$ = next.handle(request);

    if (this.#whiteLists.some((url) => request.url.includes(url))) {
      return handler$;
    }

    return handler$.pipe(catchError((err: unknown) => this.#handleError(err)));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  #handleError(err: unknown): Observable<any> {
    try {
      if (!(err instanceof HttpErrorResponse)) {
        throw err;
      }
      // サーバでエラーが発生したときはJSONで返ってくる
      if (err.status === 401) {
        // パスが文字列で渡されるので、 Router#navigate は使えない
        this.#window.location.assign(err.error.redirect_url);
      } else if (err.status === 403) {
        this.#errorService.redirectTo403();
      } else if (err.status === 404) {
        this.#errorService.redirectTo404();
      } else {
        const { title, message } = err.error;
        this.#errorService.redirectToErrorPage({
          title: title ?? 'システムエラー',
          message: message ?? this.#DEFAULT_ERROR_MESSAGE,
        });
        return throwError(() => err);
      }
      return NEVER;
    } catch (e) {
      // サーバがダウンしてるなど
      this.#errorService.redirectToErrorPage({
        title: 'システムエラー',
        message: e.message || this.#DEFAULT_ERROR_MESSAGE,
      });
      return throwError(() => e);
    }
  }
}
